export const FILTER_MAX_TAGS_COUNT = 100;
